// @ts-nocheck
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

import { ArrowRight } from '@phosphor-icons/react';
import { motion } from 'framer-motion';
import { Text, XStack, YStack } from 'tamagui';

import { Header, Footer } from '../../components/landing';
import { USE_CASES } from './useCaseData';

export default function UseCasesIndex() {
  const [isMobile, setIsMobile] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth < 768);
    handleResize();
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return (
    <YStack backgroundColor="$background" minHeight="100vh">
      <Header />

      <YStack
        paddingTop={140}
        paddingBottom={100}
        paddingHorizontal="$5"
        maxWidth={1100}
        alignSelf="center"
        width="100%"
        gap="$8"
      >
        {/* Hero */}
        <YStack alignItems="center" gap="$4">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5 }}
            style={{ textAlign: 'center' }}
          >
            <Text
              fontSize={13}
              fontWeight="600"
              color="#ededed"
              letterSpacing={2}
              textTransform="uppercase"
            >
              Use Cases
            </Text>
          </motion.div>
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5, delay: 0.1 }}
            style={{ textAlign: 'center' }}
          >
            <Text
              fontSize={isMobile ? 32 : 48}
              fontWeight="700"
              textAlign="center"
              letterSpacing={-2}
              lineHeight={isMobile ? 38 : 54}
              color="$color12"
            >
              Built for how you work
            </Text>
          </motion.div>
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5, delay: 0.15 }}
            style={{ textAlign: 'center' }}
          >
            <Text
              fontSize={isMobile ? 16 : 18}
              textAlign="center"
              color="$color9"
              maxWidth={600}
              lineHeight={28}
            >
              Whether you work solo, lead a team, or manage a distributed org — Torch adapts to your workflow.
            </Text>
          </motion.div>
        </YStack>

        {/* Cards Grid */}
        <XStack
          flexWrap="wrap"
          gap="$5"
          justifyContent="center"
        >
          {USE_CASES.map((useCase, index) => (
            <motion.div
              key={useCase.slug}
              initial={{ opacity: 0, y: 30 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5, delay: 0.2 + index * 0.1 }}
              style={{
                width: isMobile ? '100%' : 'calc(50% - 12px)',
                minWidth: isMobile ? undefined : 460,
                maxWidth: 540,
                cursor: 'pointer',
              }}
              onClick={() => navigate(`/use-cases/${useCase.slug}`)}
            >
              <YStack
                padding="$6"
                borderRadius="$2"
                borderWidth={1}
                borderColor="$color4"
                backgroundColor="$color2"
                gap="$4"
                hoverStyle={{
                  borderColor: '#ededed',
                  backgroundColor: '$color3',
                }}
                style={{
                  transition: 'all 0.2s ease',
                } as any}
                height="100%"
              >
                <XStack alignItems="center" gap="$3">
                  <XStack
                    width={44}
                    height={44}
                    borderRadius="$2"
                    alignItems="center"
                    justifyContent="center"
                    style={{
                      background: `linear-gradient(135deg, ${useCase.iconColor}22 0%, ${useCase.iconColor}11 100%)`,
                      border: `1px solid ${useCase.iconColor}33`,
                    }}
                  >
                    <useCase.icon size={22} color={useCase.iconColor} />
                  </XStack>
                  <Text fontSize={13} fontWeight="600" color={useCase.iconColor} letterSpacing={1} textTransform="uppercase">
                    {useCase.title}
                  </Text>
                </XStack>

                <Text
                  fontSize={isMobile ? 22 : 26}
                  fontWeight="700"
                  color="$color12"
                  letterSpacing={-0.5}
                  lineHeight={isMobile ? 28 : 32}
                >
                  {useCase.headline}
                </Text>

                <Text
                  fontSize={15}
                  color="$color9"
                  lineHeight={24}
                >
                  {useCase.subtitle}
                </Text>

                <XStack alignItems="center" gap="$2" marginTop="$2">
                  <Text fontSize={14} fontWeight="600" color="#ededed">
                    Learn more
                  </Text>
                  <ArrowRight size={14} color="#ededed" />
                </XStack>
              </YStack>
            </motion.div>
          ))}
        </XStack>
      </YStack>

      <Footer />
    </YStack>
  );
}
